export default "__VITE_ASSET__OYBni$JO__"